<template>
  <div>
    <commond-form
      :request="formData"
      :route="'/v1/emision/manual/actualizar'"
      :run="run"
      :action="'POST'"
      @cancel="run = false"
      @success="onFormSuccess"
      @afterError="$emit('changeTab', 1)"
    >
      <template v-slot:data>
        <v-row>
          <v-col m="12" md="6" lg="3" xl="3">
            <v-text-field
              label="Teléfono "
              outlined
              color="#00a7e4"
              v-mask="'##########'"
              v-model="formData.telefono"
              :rules="required"
            ></v-text-field>
          </v-col>
          <v-col m="12" md="6" lg="3" xl="3">
            <common-email-autocomplete
              :emailEdit="clienteInfo.correo"
              @emailUpdate="(e) => (formData.correo_electronico = e)"
            >
            </common-email-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
            xl="12"
            style="text-align: end;"
          >
            <v-btn
              rounded
              dark
              color="#00a7e4"
              outlined
              @click="$emit('changeTab', 1)"
              style="margin-right: 20px;"
            >
              <span style="padding-right: 11%;">
                Cancelar
              </span>
            </v-btn>
            <v-btn rounded dark class="common-botton" @click="run = true">
              <span style="padding-right: 11%;">
                Guardar
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </commond-form>
  </div>
</template>

<script>
import CommonEmailAutocomplete from "@/components/commonComponents/CommonEmailAutocomplete.vue";
import CommondForm from "@/components/commonComponents/CommondForm.vue";
import { mainAxios } from "@/mainAxios.js";

export default {
  components: {
    CommonEmailAutocomplete,
    CommondForm,
  },

  data() {
    return {
      switch_data: 1,
      required: [(value) => !!value || "Campo Requerido"],
      formData: {
        id: null,
        telefono: null,
        correo_electronico: null,
      },
      run: false,
    };
  },
  props: {
    polizaInfo: Object,
    clienteInfo: Object
  },
  watch: {
    polizaInfo() {
      this.fillData();
    },
  },
  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      this.formData.id = this.polizaInfo.id;
      this.formData.telefono = this.clienteInfo.telefonoMovil;
      this.formData.correo_electronico = this.clienteInfo.correo;
    },
    async onFormSuccess() {
      const payload = {
        celular: this.formData.telefono,
        correo: this.formData.correo_electronico
      }

      const config = {
          headers: {
            Authorization: "Bearer " + localStorage.agenteAccessToken,
          },
      };

      try {
        await mainAxios.post(
          `/v1/cliente/update/${this.polizaInfo.cliente}`,
          payload,
          config
        );
        this.$emit('getData'); 
      } catch (error) {
        this.$toast.error('Error actualizando datos del cliente:', error);
      }

    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table {
  background-color: #81cfe61a;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 20px;
}

.v-expansion-panel {
  border-radius: 20px;
}
.v-expansion-panels {
  z-index: auto !important;
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
}

.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #81cfe61a;
  color: rgba(0, 0, 0, 0.87);
}
</style>
